class i extends HTMLElement {
  constructor() {
    super(), (this.container = this);
    const e = {rootMargin: '0px 0px 200px 0px'};
    new IntersectionObserver(this.handleIntersection.bind(this), e).observe(this.container);
  }
  handleIntersection(e, o) {
    e[0].isIntersecting &&
      (o.unobserve(this),
      fetch(this.dataset.url)
        .then((t) => {
          if (!t.ok) throw new Error(`Failed to get cart product recommendations. ${t.status} - ${t.statusText}`);
          return t.text();
        })
        .then((t) => {
          const n = document.createElement('div');
          n.innerHTML = t;
          const r = n.querySelector('product-recommendations');
          r && r.innerHTML.trim().length && (this.innerHTML = r.innerHTML),
            n.querySelector('.grid__item') && this.container.classList.add('product-recommendations--loaded');
        })
        .catch((t) => {
          window.console.warn(t);
        }));
  }
}
customElements.get('product-recommendations') || customElements.define('product-recommendations', i);
